import { theme } from '../../styles/theme';
export const authPageLeftPanelHeader = {
    fontWeight: 800,
    color: theme.palette.common.darkGrey6,
    fontSize: '72px',
    lineHeight: '80px',
    letterSpacing: '-2px',
    marginTop: '-80px'
};
export const authPageLeftPanelDescription = {
    fontWeight: 600,
    fontSize: '18px',
    marginTop: '24px'
};
export const authPageLeftPanelImg = {
    alignSelf: 'end',
    width: '347px',
    height: '323px'
};
//# sourceMappingURL=AuthPageLeftPanel.styles.js.map